"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var BarcodeScannerHandler_1 = require("../../../../../Services/BarcodeScannerHandler");
var PackIdentifier_1 = require("../../../../../Types/PackIdentifier");
var Services_1 = require("../../../../../Services");
var Types_1 = require("../../../../../Types");
var SignalR = require("@microsoft/signalr");
var maxNumberofPacks = 40;
var ScanArea = /** @class */ (function (_super) {
    __extends(ScanArea, _super);
    function ScanArea(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.barcodeScannerHandler = new BarcodeScannerHandler_1.BarcodeScannerHandler(_this.onScan.bind(_this));
        document.addEventListener("keypress", _this.barcodeScannerHandler.keyPressHandler, true);
        document.addEventListener("keydown", _this.barcodeScannerHandler.keyDownHandler, true);
        document.addEventListener("keyup", _this.barcodeScannerHandler.keyUpHandler, true);
        return _this;
    }
    ScanArea.prototype.componentWillUnmount = function () {
        document.removeEventListener("keypress", this.barcodeScannerHandler.keyPressHandler, true);
        document.removeEventListener("keydown", this.barcodeScannerHandler.keyDownHandler, true);
        document.removeEventListener("keyup", this.barcodeScannerHandler.keyUpHandler, true);
    };
    ScanArea.prototype.onScan = function (dom3KeyboardEventCodeSupport) {
        var _this = this;
        if (this.props.connectionState != SignalR.HubConnectionState.Connected) {
            Services_1.EventHandlerProvider.GetInstance().AddEvent(new Types_1.VeriLiteWarningEvent(this.props.resources.VeriLiteDisconnected));
            return;
        }
        if (this.props.scannedPacks.length >= maxNumberofPacks) {
            this.props.setAlert("Error_MaxBulkRequestSizeExceeded");
            return;
        }
        var scannedData = dom3KeyboardEventCodeSupport ?
            this.barcodeScannerHandler.scannerInput.getInput() :
            this.barcodeScannerHandler.scannerInput.getInputBytes();
        var scannedString = String.fromCharCode.apply(String, scannedData);
        if (scannedData.length > 20) {
            var json = JSON.stringify({ ScannedData: scannedString, CalibrationData: this.props.calibrationData });
            var headers = new Headers();
            headers.append("content-type", "application/json;");
            fetch("/Parser/Parse", {
                headers: headers,
                method: "post",
                body: json
            })
                .then(function (response) {
                PackIdentifier_1.PackIdentifier.fromPromise(response.json())
                    .then(function (newPack) {
                    if (newPack.submit) {
                        if (_this.props.scannedPacks.some(function (pack) { return (pack.key() == newPack.key()); })) {
                            _this.props.setAlert("InvalidBulkRequest_DuplicatesNotAllowed");
                        }
                        else {
                            _this.props.addPack(newPack);
                        }
                    }
                    else {
                        _this.props.setAlert("CannotParseBarcode");
                    }
                });
            });
        }
    };
    ScanArea.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(reactstrap_1.Progress, { value: this.props.scannedPacks.length, max: 40 },
                this.props.scannedPacks.length,
                "/40"),
            React.createElement(reactstrap_1.Table, { striped: true, size: "sm" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, this.props.resources.ProductCode),
                        React.createElement("th", null, this.props.resources.SerialNumber),
                        React.createElement("th", null, this.props.resources.BatchID),
                        React.createElement("th", null, this.props.resources.ExpiryDate),
                        React.createElement("th", null, " "))),
                React.createElement("tbody", null, this.props.scannedPacks.map(function (pack) {
                    return React.createElement("tr", { key: pack.key() },
                        React.createElement("td", null, pack.productCode),
                        React.createElement("td", null, pack.serialNumber),
                        React.createElement("td", null, pack.batchIdentifier),
                        React.createElement("td", null, pack.getFormatExpiryDate()),
                        React.createElement("td", null,
                            " ",
                            React.createElement(reactstrap_1.Button, { close: true, onClick: function () {
                                    _this.props.removePack(pack);
                                } })));
                })))));
    };
    return ScanArea;
}(React.Component));
exports.ScanArea = ScanArea;
//# sourceMappingURL=ScanArea.js.map